import styled from "styled-components";
import { useDrag, useDrop, DragPreviewImage } from "react-dnd";

const FieldWrapper = styled.div`
  width: 25%;

  padding: 4px;
`;

const StyledField = styled.div`
  background: ${(p) => p.theme.colors.surface};
  padding: 5px 15px;
  border: 1px solid ${(p) => p.theme.colors.border.surface};
  border-radius: 4px;
  cursor: grab;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const ComponentType = styled.div`
  font-size: 0.6rem;
  font-weight: bold;
  text-transform: uppercase;
  font-family: "Open Sans";
`;

const ComponentName = styled.div``;

const Field = (props) => {
  const type2ComponentMap = {
    text: "Input",
    relation: "Dropdown",
  };

  const readonly2ComponentMap = {
    text: "Heading",
    relation: "EffectCard",
  };

  const generateExtra = (type, id, name, relCollectionId) => {
    switch (type) {
      case "Heading": {
        return {
          label: `{{effects.${id}.${name}}}`,
          tagName: "div",
        };
      }
      case "Dropdown": {
        return {
          label: `Add label/value`,
          defaultStatic: true,
          staticValue: `{{effects.${id}.${name}._id}}`,
          optionsType: "effects",
          effects: [
            {
              name: "Register/getContent",
              source: "Register/getContent",
              async: true,
              crashBehaviour: "warn",
              optionsType: "effects",
              group: "Register",
              icon: "fal fa-database",
              registerId: `${relCollectionId}`,
              projection:
                '[{"src":"_id","dst":"label"},{"src":"_id","dst":"value"}]',
            },
          ],
        };
      }
      case "EffectCard": {
        return {
          cardWidth: "100%",
          showHitCount: false,
          noResultLabel: "EffectCard.NoResults",
          noHitsLabel: "EffectCard.NoHitsLabel",
          name: `{{effects.${id}.${name}}}`,
          pageSize: null,
          effects: {
            source: "Params/client",
            param: `effects.${id}.${name}`,
          },
          templateId: "_custom",
          template: "<div>{{_id}}</div>",
        };
      }
      default:
        return {
          defaultValue: "static",
          staticValue: `{{effects.${id}.${name}}}`,
        };
    }
  };

  const { field = {}, id, readonly } = props;

  const { name, type, relCollectionId } = field;

  const componentType = readonly
    ? readonly2ComponentMap[type]
      ? readonly2ComponentMap[type]
      : "Heading"
    : type2ComponentMap[type]
    ? type2ComponentMap[type]
    : "Input";

  const [{ isDragging }, drag, _preview] = useDrag(() => ({
    type: "component",
    item: {
      action: "create",
      type: componentType,
      name,
      defaultExtra: generateExtra(componentType, id, name, relCollectionId),
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  console.log("444prsop", props);

  return (
    <FieldWrapper ref={drag}>
      <StyledField>
        <ComponentType>{componentType}</ComponentType>
        <ComponentName>{name}</ComponentName>
      </StyledField>
    </FieldWrapper>
  );
};

export default Field;
